/**
 * Construction Module Routes (extracted from index.tsx)
 */
import React from 'react';
import { Result } from 'antd';
import { RouteItem } from './index';
import { HomeOutlined, FormOutlined, FileOutlined, OrderedListOutlined, PlusOutlined, AreaChartOutlined } from '@ant-design/icons';
import { TbReportAnalytics } from 'react-icons/tb';

// Shared forms components
import FormDefinitionsList from "../components/common/Forms/FormDefinitionsList";
import FormDefinitionEditor from "../components/common/Forms/FormDefinitionEditor";
import PdfToReactFormGenerator from "../components/common/Forms/PdfToReactFormGenerator";
import FormRecordDetailsList from '../components/common/Forms/FormRecordDetailsList';

// Construction pages
import ConstFormsCreate from "../pages/construction/forms/ConstFormsCreate";
import ConstFormFill from "../pages/construction/forms/ConstFormFill";
import ConstFormList from "../pages/construction/forms/ConstFormList";
import ConstFormEdit from '../pages/construction/forms/ConstFormEdit';
import ConstFormView from '../pages/construction/forms/ConstFormView';
import ConstFormGroupCreate from "../pages/construction/forms/ConstFormGroupCreate";

import ConstPipingDataTables  from "../pages/construction/piping/ConstPipingDataTables";
import ConstPipingPgDataTables from "../pages/construction/piping/ConstPipingPgDataTables";
import ConstPipingPgTableDetails from "../pages/construction/piping/ConstPipingPgTableDetails";

const UnderConstruction = ({ title }: { title: string }) => (
  <Result status="info" title={`${title} Module`} subTitle="Under Construction." />
);

// Wrapper for react-icons typing
const RTbReportAnalytics: React.FC<any> = (props) =>
  React.createElement(TbReportAnalytics as unknown as React.ComponentType<any>, props) as React.ReactElement;

export const constructionRoutes: Record<string, RouteItem> = {
  // CONSTRUCTION modülü
  construction: {path: '/construction', element: null, label: 'Construction', showInMenu: false,
    children: {
      dashboard: { path: '/construction/dashboard', element: <UnderConstruction title={'Construction'}/>, label: 'Dashboard', icon: <HomeOutlined/>, showInMenu: true},
      dailyReport: { path: '/construction/daily-report', element: <UnderConstruction title="Daily Report"/>,label: 'Daily Report',   icon: <RTbReportAnalytics size={18} />, showInMenu: true},
      precom: { path: '/construction/precom', element: <UnderConstruction title="Precom"/>,label: 'Precom', icon: <AreaChartOutlined/>, showInMenu: true },
      forms: { path: '/construction/forms', element: <ConstFormList/>, label: 'Forms', icon: <FormOutlined/>, showInMenu: true,
        grandchildren: {
          list: { path: '/construction/forms/list', element: <ConstFormList/>,  label: 'Form List', icon: <FileOutlined/>, showInMenu: true },
          definitions: { path: '/construction/forms/definitions', element: <FormDefinitionsList />, label: 'Form Definitions', icon: <OrderedListOutlined />, showInMenu: true },
          definitions_create: { path: '/construction/forms/definitions/create', element: <PdfToReactFormGenerator />, label: 'Create Form Definition', showInMenu: false },
          definitions_edit: { path: '/construction/forms/definitions/edit/:id', element: <FormDefinitionEditor />, label: 'Edit Form Definition', showInMenu: false },
          list_record_details: { path: '/construction/forms/list_record_details', element: <FormRecordDetailsList />,  label: 'Form Record Details', icon: <FileOutlined/>, showInMenu: true },
          group: { path: '/construction/forms/gr_create', element: <ConstFormGroupCreate/>, label: 'New Form Group', icon: <PlusOutlined/>, showInMenu: true},
          create: { path: '/construction/forms/create', element: <ConstFormsCreate/>, label: 'Create Form', icon: <PlusOutlined/>,showInMenu: true },
          fill: {path: '/construction/forms/fill', element: <ConstFormFill/>, label: 'Fill Form', showInMenu: true},
          edit: { path: '/construction/forms/edit/:id',    element: <ConstFormEdit/>, label: 'Edit Form', showInMenu: false },
          view: { path: '/construction/forms/view/:id',    element: <ConstFormView/>, label: 'View Form', showInMenu: false },
        },
      },
    piping: {path: '/construction/piping', element: <UnderConstruction title="Piping"/>, label: 'Piping', icon: <AreaChartOutlined/>, showInMenu: true,
        grandchildren: {
          tables: {path: '/construction/piping/tables', element: <ConstPipingDataTables/>, label: 'Piping', icon: <AreaChartOutlined/>,  showInMenu: true  },
          pgTables: {path: '/construction/piping/pg-tables', element: <ConstPipingPgDataTables/>, label: 'Piping (PG)', icon: <AreaChartOutlined/>, showInMenu: true },
        },
      },
    },
  },
};
